import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';
import { useLocation } from 'react-router-dom';

/**
 * Guest strip — replaces the legacy "Preview Mode — sample data shown" banner
 * that Grok flagged as a trust killer. Now framed as value (free score, no
 * account) instead of limitation.
 *
 * Hidden on the marketing landing pages (/, /slaw-landing) where the hero
 * already carries the CTA — we don't want a duplicate ribbon stacked above it.
 */
export default function GuestBanner() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();

  if (loading || user) return null;

  // Suppress on landing pages (hero already owns the CTA there)
  if (pathname === '/' || pathname === '/slaw-landing' || pathname === '/slaw-report-success') {
    return null;
  }

  return (
    <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent border-b border-primary/15 px-4 py-2 flex items-center justify-between gap-3 text-[12px] shrink-0">
      <div className="flex items-center gap-2 text-foreground">
        <Sparkles className="h-3.5 w-3.5 text-primary shrink-0" />
        <span className="text-muted-foreground">
          <strong className="text-foreground">Free public access</strong> — score any entity, no account required.
        </span>
      </div>
      <Link
        to="/auth"
        className="hidden sm:flex items-center gap-1.5 px-3 py-1 rounded-md text-primary hover:text-primary-foreground hover:bg-primary font-semibold transition-colors text-[11px] border border-primary/30"
      >
        Save your reports
        <ArrowRight className="h-3 w-3" />
      </Link>
    </div>
  );
}
